<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent && !windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="('Send Reservation Data from' | translate) + ' ' + integration?.guest_reservation_source_type?.name + ' ' + ('to TIDY' | translate)"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper
    [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''"
    [style]="!windowService?.isDesktopRes ? 'margin-top: 5rem;' : ''">
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />
    <ng-container>
      @if (windowService?.isDesktopRes) {
        <tidy-desktop-header>
          <div class="wrappable-container">
            <tidy-image
              [src]="'assets/svg/arrow-back-black.svg'"
              (action)="goBack()"
              class="desktop-back-icon" />
            <tidy-text
              [title]="('Send Reservation Data from' | translate) + ' ' + integration?.guest_reservation_source_type?.name + ' ' + ('to TIDY' | translate)" />
          </div>
        </tidy-desktop-header>
      }
      @if (savingText.length > 0) {
        <tidy-row>
          <tidy-text [body]="savingText" />
        </tidy-row>
      }
      <tidy-row>
        <tidy-text
          [helper]="'We will show this data to pros or customers who have access to it. Match the data from your PMS to TIDY, or use the defaults.'" />
      </tidy-row>
      <tidy-card>
        <div style="display: flex; gap: 10px; align-items: center">
          <div style="flex: 1">
            <tidy-row style="margin-bottom: 1rem">
              <tidy-text
              [header]="integration?.guest_reservation_source_type?.name" />
            </tidy-row>
          </div>
          <div style="flex: 0.1; margin-left: 10px"></div>
          <div style="flex: 1">
            <tidy-row style="margin-bottom: 1rem">
              <tidy-text [header]="'TIDY'" />
            </tidy-row>
          </div>
          <div style="flex: 0.2; margin-left: 10px">
            <tidy-text [header]="'Visible to Pros'" />
          </div>
        </div>
        @if (!loaded) {
          @for (item of [1,2,3,4,5,6,7,8,9,10]; track item) {
            <div style="display: flex; gap: 10px; align-items: center">
              <ion-skeleton-text
                animated="true"
                style="
                  width: 100%;
                  height: 64px;
                  border-radius: 8px;
                " />
            </div>
          }
        }
        @if (loaded) {
          <form [formGroup]="form">
            @for (field of getSortedFormControls(); track field; let i = $index) {
              <div>
                <form
                  [formGroup]="field"
                  [class.highlighted]="hoveredFieldName === field.get('field_name')?.value"
                  (mouseenter)="hoveredFieldName = field.get('field_name')?.value"
                  (mouseleave)="hoveredFieldName = null"
                  style="display: flex; gap: 10px; align-items: center">
                  <div style="flex: 1">
                    <tidy-select
                      [label]="''"
                      [icon]="'assets/svg/sync.svg'"
                      [items]="parsedVariables"
                      [multiple]="false"
                      [form]="field.get('source_data')"
                      formControlName="source_data" />
                  </div>
                  <div style="flex: 0.1; margin-left: 10px">
                    <mat-icon>chevron_right</mat-icon>
                  </div>
                  <div style="flex: 1">
                    <div>
                      <tidy-text
                      [body]="field?.get('field_name')?.value || ''" />
                    </div>
                  </div>
                  <div style="flex: 0.2; margin-left: 10px; position: relative;">
                    @if (field?.get('type')?.value === 'OverridableTidyField') {
                      <div
                        class="checkbox-question-mark-icon"
                        matTooltip="This field cannot be hidden from pros"
                        matTooltipPosition="above">
                        <mat-icon class="small-icon">help_outline</mat-icon>
                      </div>
                    }
                    <tidy-checkbox
                      [items]="[{value: true, viewValue: ''}]"
                      [initValue]="field?.get('type')?.value === 'OverridableTidyField' ? true : field?.get('is_visible_to_homekeeper')?.value"
                      [formControlName]="'is_visible_to_homekeeper'"
                      [form]="field?.controls.is_visible_to_homekeeper"
                      [class.disabled]="field?.get('type')?.value === 'OverridableTidyField'"
                      [disabled]="field?.get('type')?.value === 'OverridableTidyField'"
                      (checkedChange)="updateCustomField(field)" />
                  </div>
                </form>
              </div>
            }
          </form>
          <div style="display: flex; gap: 10px; align-items: center">
            <div style="flex: 1"></div>
            <div style="flex: 0.1; margin-left: 10px"></div>
            <div style="flex: 1">
              <tidy-row style="margin-bottom: 1rem">
                <tidy-text
                  [actionBody]="'+ Create Custom Field'"
                  class="link"
                  (action)="addCustomField()" />
              </tidy-row>
            </div>
          </div>
        }
      </tidy-card>

      <tidy-row>
        <tidy-text [header]="'Reservation Card Example'" />
      </tidy-row>

      <tidy-card>
        <tidy-row class="vertical-align-center">
          <tidy-image
            [src]="'assets/img/calendar-link.svg'"
            class="header-size" />
          <tidy-text
            [header]="(guestReservation?.check_in_date | customdate:'M/DD/YY') + ' - ' + (guestReservation?.check_out_date | customdate:'M/DD/YY')" /><span>&nbsp;</span>
            <tidy-text [header]="'Reservation'" />
          </tidy-row>
          <tidy-row class="vertical-align-center extra-top-padding">
            <tidy-image [src]="'assets/svg/home.svg'" class="body-size" />
            <tidy-text [body]="addressName" />
          </tidy-row>

          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/svg/time.svg'" class="body-size" />
            <tidy-text [body]="'Check In:'" /><span>&nbsp;</span>
            <tidy-text
              [body]="guestReservation?.check_in_time | customdate:'h:mma':'local':'HH:mm'" /><span>&nbsp;</span>
              <tidy-text
                [body]="guestReservation?.check_in_date | customdate:'M/DD/YY'" />
            </tidy-row>

            <tidy-row class="vertical-align-center">
              <tidy-image [src]="'assets/svg/time.svg'" class="body-size" />
              <tidy-text [body]="'Check Out:'" /><span>&nbsp;</span>
              <tidy-text
                [body]="guestReservation?.check_out_time | customdate:'h:mma':'local':'HH:mm'" /><span>&nbsp;</span>
                <tidy-text
                  [body]="guestReservation?.check_out_date | customdate:'M/DD/YY'" />
              </tidy-row>

              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/svg/information-circle.svg'"
                  class="body-size" />
                <tidy-text [body]="'Synced from'" /><span>&nbsp;</span>
                <tidy-text [body]="integration?.guest_reservation_source_type?.name" /><span>&nbsp;</span>
                  <tidy-text
                    [body]="'integration'"
                    (action)="goToIntegrations()"
                    class="link" />
                </tidy-row>

                <ng-container>
                  <tidy-row class="vertical-align-center">
                    <tidy-image [src]="'assets/icon/group.png'" class="body-size" />
                    <tidy-text [body]="'2 guests'" />
                  </tidy-row>
                </ng-container>

                @if (getOverridableReservationMappings()?.length > 0) {
                  @for (mapping of getOverridableReservationMappings(); track mapping) {
                    <tidy-row
                      class="vertical-align-center"
                      [class.highlighted]="hoveredFieldName === mapping.field?.field_name"
                      (mouseenter)="hoveredFieldName = mapping.field?.field_name"
                      (mouseleave)="hoveredFieldName = null">
                      <tidy-image
                        [src]="'assets/svg/information-circle.svg'"
                        class="body-size" />
                      <tidy-text
                      [body]="mapping.field?.field_name + ': ' + ' ' + mapping.source_data || 'N/A'" />
                    </tidy-row>
                  }
                }

                @if (customFields?.length > 0) {
                  @for (customField of customFields; track customField) {
                    <tidy-row
                      class="vertical-align-center"
                      [class.highlighted]="hoveredFieldName === customField.name"
                      (mouseenter)="hoveredFieldName = customField.name"
                      (mouseleave)="hoveredFieldName = null">
                      <tidy-image
                        [src]="'assets/svg/information-circle.svg'"
                        class="body-size" />
                      <tidy-text
                      [body]="customField?.name + ': ' + ' ' + (customField?.value && customField?.value?.toLowerCase() !== 'none' && !customField?.value?.includes('{{') && !customField?.value?.includes('}}') ? '{{' + (customField?.value | translate) + '}}' : (customField?.value || 'N/A' | translate))" />
                    </tidy-row>
                  }
                }
              </tidy-card>
            </ng-container>
          </tidy-wrapper>
        </ng-template>

        @if (!isRightSideContent) {
          <app-scroll-wrapper
            [templateContent]="content"
          [isfullWidthContent]="true" />
        }

        @if (isRightSideContent) {
          <ion-content class="ion-content-right-column">
            <ng-container *ngTemplateOutlet="content" />
          </ion-content>
        }
